import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractPopupMediator from "../../../core/ui/AbstractPopupMediator";
import MapCharacterInteractionEvent from "../event/MapCharacterInteractionEvent";
import MapCharacterDefinition from "../model/MapCharacterDefinition";

export default class MapCharacterInformationPopupMediator extends AbstractPopupMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;

        /** @type {MapCharacterDefinition} */
        this._character = this.getCustomData().character;
    }

    initialize() {
        super.initialize();

        this.preventClickThrough();

        this._target.panel.titleTextField.text = this._languagePack.getText(`map.characters.${this._character.id}.title`);
        this._target.panel.descriptionTextField.text = this._languagePack.getText(`map.characters.${this._character.id}.description`);

        this.createButton(this._target.panel.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText('map.nodeInformation.continueButtonLabel'));
        this.createButton(this._target.panel.closeButton, this.close.bind(this));

        this.stretchBackground(this._target.overlay);
        this._animateIn();
    }

    // override super.close
    close() {
        this.disableInteraction();

        const onClose = this._target.onClose;
        if (onClose != null) {
            onClose();
        }

        this._animateOut()
            .finally(_ => this.closePopup(this._target));
    }

    _handleContinueButton() {
        this.disableInteraction();

        const mapNodeInteractionEvent = new MapCharacterInteractionEvent(MapCharacterInteractionEvent.ENTER, this._character);
        this.dispatch(mapNodeInteractionEvent.type, { data: mapNodeInteractionEvent });

        this.close();
    }

    _animateIn() {
        this._target.overlay.alpha = 0;
        this._target.panel.alpha = 0;
        this._target.panel.scale = 0;
        this._target.panel.closeButton.scale = 0;

        createjs.Tween.get(this._target.overlay)
            .to({ alpha: 1 }, 450, createjs.Ease.sineOut);

        createjs.Tween.get(this._target.panel)
            .wait(100)
            .to({ alpha: 1, scale: 1 }, 350, createjs.Ease.backOut);

        createjs.Tween.get(this._target.panel.closeButton)
            .wait(450)
            .to({ scale: 1 }, 350, createjs.Ease.backOut);
    }

    _animateOut() {
        return new Promise(resolve => {
            createjs.Tween.get(this._target.overlay)
                .wait(100)
                .to({ alpha: 0 }, 350, createjs.Ease.sineOut);

            createjs.Tween.get(this._target.panel)
                .to({ alpha: 0, scale: 0 }, 450, createjs.Ease.backIn)
                .call(resolve);
        });
    }
}
